import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent";
import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FormattedHTMLMessage, FormattedMessage, useIntl } from "react-intl";
import GuideContext from '../GuideContext';

import ReactSVG from "react-svg";

const Product = ({
  product,
  actionCompleted,
  onClick,
  horizontalLayout = true,
  productFeaturesExpanded = false,
  toggleProductInCart,
  productIsInCart,
}) => {
  const intl = useIntl();

  const cssBEM = "product";

  const svgPath = getMessageValue(intl.locale, `${ product.id }.icon`);

  const { isBusinessGuide } = useContext(GuideContext);

  const [featuresDisplayed, setFeaturesDisplayed] = useState(productFeaturesExpanded);

  const featureList = useRef(null);

  useEffect(() => {
    if (isBusinessGuide && featureList) {
      if (featuresDisplayed) {
        featureList.current.style.maxHeight = featureList.current.scrollHeight + 'px';
      } else {
        featureList.current.style.maxHeight = 0;
      }
    }
  }, [featuresDisplayed]);

  const toggleFeatureDisplay = () => {
    setFeaturesDisplayed(!featuresDisplayed);
  }

  const productActionCompleted = (actionName, value, append = false) => {
    actionCompleted(actionName, product.id, value, append);
  };

  const learnMoreClicked = (url) => {
    productActionCompleted("productDetailsClicked", "learnMore", true);
    window.open(url, '_blank')
  }

  const renderActionButtons = () => (
    <div className="cartButtons">
      <MessageIfPresent id={`${ product.id }.url`}>
        <FormattedMessage id={`${ product.id }.url`}>
          {(url) => (
            <button
              className="btn btn-secondary"
              onClick={() => learnMoreClicked(url)}
            >
              <FormattedMessage id="product.learnMore.button" />
            </button>
          )}
        </FormattedMessage>
      </MessageIfPresent>
      <button
        className={`btn btn-primary ${productIsInCart ? 'btn-active' : ''}`}
        onClick={() => toggleProductInCart(product.id)}
      >
        {productIsInCart ? (<><FormattedMessage id="removeFromCart" /> <i class="icon fa fa-check-circle"></i></>) : (<FormattedMessage id="addToCart" />)}
      </button>
    </div>
  )

  const renderProductFeatures = () => {
    const count = getMessageValue(intl.locale, `${ product.id }.features.count`);
    const features = Array(count)
      .fill(1)
      .map((v, index) => {
        const msgIndex = index + 1;
        const id = `${ product.id }.features.${ msgIndex }`;
        return (
          <MessageIfPresent id={id} key={id}>
            <FormattedHTMLMessage id={id} tagName="li" />
          </MessageIfPresent>
        );
      });
    return features.length && isBusinessGuide ? (
      <div className={`${ cssBEM }__features`}>
        <MessageIfPresent id="features.title" key="features.title">
          <FormattedHTMLMessage id="features.title" tagName="span" />
          <i
            onClick={toggleFeatureDisplay}
            className={`lni lni-chevron-${ featuresDisplayed ? "down" : "right" }`}
          />
        </MessageIfPresent>
        <ul
          ref={featureList}
          className={`feature-list`}
        >
          {features}
        </ul>
      </div>
    ) : (<></>);
  };

  if (horizontalLayout) {
    return (
      <div className={`${ cssBEM }`} key={product.id} onClick={onClick}>
        <div className={`${ cssBEM }__productInfo`}>
          <div className={`${ cssBEM }__header`}>
            <ReactSVG src={svgPath} />
            <h1 className={`${ cssBEM }`}>
              <FormattedMessage id={`${ product.id }.name`} />
            </h1>
          </div>
          <div className={`${ cssBEM }__description`}>
            <MessageIfPresent id={`${ product.id }.description`}>
              <FormattedHTMLMessage
                id={`${ product.id }.description`}
                tagName="p"
              />
            </MessageIfPresent>
          </div>
          {renderProductFeatures()}
        </div>
        <div className={`${ cssBEM }__productActions`}>
          <div className={`${ cssBEM }__cta`}>
            {renderActionButtons()}
          </div>
        </div>

      </div>
    );
  } else {
    // This appears to be outdated and unused code
    return (
      <div className={cssBEM} key={product.id} onClick={onClick}>
        <div className={`${ cssBEM }__content`}>
          <div className={`${ cssBEM }__header`}>
            <ReactSVG src={svgPath} />
          </div>
          <div className={`${ cssBEM }__description`}>
            <h1 className={`${ cssBEM } ${ isBusinessGuide ? 'business' : '' }`}>
              <FormattedMessage id={`${ product.id }.name`} />
            </h1>
            <MessageIfPresent id={`${ product.id }.description`}>
              <FormattedHTMLMessage
                id={`${ product.id }.description`}
                tagName="p"
              />
            </MessageIfPresent>
            {renderProductFeatures()}
          </div>
        </div>
        <div className={`${ cssBEM }__cta ${ isBusinessGuide ? 'business' : '' }`}></div>
      </div>
    );
  }
};

export default Product;
